/* SCORE GLOBAL : moyenne simple des categories (regle de Nawal du 07/10/2026,
   fiche « Review 5c oct THE LAB », point 3.3).

   - Score d'une categorie : points obtenus / points possibles, SANS arrondi.
   - Score global : moyenne de ces scores, arrondie a l'unite a la fin (,5 vers
     le haut). Exemple de la fiche : Empathie 3/4 (75 %) et Ecoute 1/2 (50 %)
     donnent 62,5, donc 63 % (l'ancien calcul, 4/6 points, donnait 67 %).
   - « master » et « glbMaster » sont des scores globaux, jamais des categories.
   - Une categorie sans point possible (max = 0) n'entre pas dans la moyenne.

   REPLIS du score GLOBAL (07/10/2026 ; « filets de securite » acceptes par
   Nawal). Le score du MODULE, lui, n'en a aucun (voir scoreDuModule) :
   1. aucune categorie RETENUE (rien de coche, ou les categories cochees sont
      absentes des reponses) : toutes les categories ;
   2. aucune categorie du tout (quiz sans categorie, ou classes « master ») :
      le total des points, comme avant (`categories.master`) ;
   3. aucun point possible nulle part : NaN, comme l'ancien 0 / 0 ; enregistre,
      il devient null (JSON).
   Sans ces replis, un module dont aucun quiz n'a de categorie (121) n'aurait
   plus de score, et un Diagnostic dont la categorie cochee manque passerait
   d'un nombre a rien.

   ⚠️ COPIE A L'IDENTIQUE dans thelab-back, services/scoreGlobal.js. La parite
   est controlee par thelab-back/tests/notation-front.test.js (500 cas tires au
   hasard sur les deux copies). */
const NON_CATEGORIES = ['master', 'glbMaster']

const estCategorie = (cle) => !NON_CATEGORIES.includes(cle)

const ratiosDe = (categories, retenir) => Object.keys(categories || {})
  .filter((cle) => estCategorie(cle) && retenir(cle))
  .map((cle) => categories[cle])
  .filter((c) => c && Number(c.max) > 0)
  .map((c) => Number(c.points) / Number(c.max))

// toFixed(9) : 0,145 * 100 vaut 14,4999... en virgule flottante ; ,5 doit monter
const pourcent = (x) => Math.round(Number((x * 100).toFixed(9)))

/* categories : { cle: { points, max, ... } } ; retenir : (cle) => booleen. */
const moyenneDesCategories = (categories, retenir = () => true) => {
  let ratios = ratiosDe(categories, retenir)
  if (ratios.length === 0) ratios = ratiosDe(categories, () => true)          // repli 1
  if (ratios.length > 0) return pourcent(ratios.reduce((a, b) => a + b, 0) / ratios.length)
  const total = categories?.master                                            // repli 2
  if (total && Number(total.max) > 0) return pourcent(Number(total.points) / Number(total.max))
  return NaN                                                                  // repli 3
}

/* glbMaster, score du module : seules les categories marquees « oui » dans la
   ponderation du module comptent. Selection manuelle, JAMAIS par defaut : une
   categorie absente de la ponderation n'entre pas (avant, elle entrait).
   ⛔ AUCUN REPLI (fiche de Nawal « Systeme de scoring », 07/10/2026, A.2 et
   A.4) : rien de coche « oui », ou des « oui » sans aucun point possible ->
   pas de score de module (NaN, enregistre null). C'est lui qui decide du
   certificat de reussite : il ne doit jamais reprendre des categories que
   Nawal n'a pas cochees (exemple de la fiche : module 142, tout sur
   « Ignorer » -> pas de score de module, pas de certificat). Les ecrans qui
   affichent « glbMaster, sinon master » montrent alors le score global. */
const retenuesParLaPonderation = (glbMasterPond) => {
  const oui = new Set((Array.isArray(glbMasterPond) ? glbMasterPond : []).filter((p) => p && p.value === 'oui').map((p) => p.key))
  return (cle) => oui.has(cle)
}
const scoreDuModule = (categories, glbMasterPond) => {
  const ratios = ratiosDe(categories, retenuesParLaPonderation(glbMasterPond))
  return ratios.length ? pourcent(ratios.reduce((a, b) => a + b, 0) / ratios.length) : NaN
}

/* Score global d'un Diagnostic : les categories cochees dans la slide
   (`format.categorie`, tableau de { key }). Aucune cochee : repli 1. */
const retenuesParLeDiagnostic = (cochees) => {
  const s = new Set((Array.isArray(cochees) ? cochees : []).filter(estCategorie))
  return (cle) => s.has(cle)
}

export { moyenneDesCategories, retenuesParLaPonderation, retenuesParLeDiagnostic, estCategorie, scoreDuModule }
